import { render, staticRenderFns } from "./AgendaAppuntamentiStatiListComponent.vue?vue&type=template&id=7d78fd07"
import script from "./AgendaAppuntamentiStatiListComponent.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentiStatiListComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaAppuntamentiStatiListComponent.vue?vue&type=style&index=0&id=7d78fd07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports